export default __webpack_public_path__ + "static/media/9805b7b34f2fff3a41c21bdaad28a503.md";